import { useCreateWeightedAverageCostOverrideMutation } from '../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useCreateWeightedAverageCostOverrideHandler( options?: any ) {
	const [ createOverride ] = useCreateWeightedAverageCostOverrideMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async(
		dateApplied: string,
		inventoryLocationId: string,
		productId: string,
		reason: string,
		weightedAverageCost: number,
	) => {
		const result = await createOverride( { variables: {
			dateApplied,
			inventoryLocationId,
			productId,
			reason,
			weightedAverageCost,
		} } )

		if ( result.data?.createWeightedAverageCostSnapshotOverride?.success ) {
			showSuccess( `createWeightedAverageCostSnapshotOverrideSuccess${Date.now()}`, result.data.createWeightedAverageCostSnapshotOverride.message )
		} else if ( result.data?.createWeightedAverageCostSnapshotOverride?.message ) {
			showError( `createWeightedAverageCostSnapshotOverrideError${Date.now()}`, result.data.createWeightedAverageCostSnapshotOverride.message )
		}
	}
}
